/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  NotFoundExceptionModel,
  UserCourseInstanceModel,
} from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class UserCourseInstance<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags UserCourseInstance
   * @name GetUserCourseInstanceById
   * @request GET:/api/UserCourseInstance/{userCourseInstanceId}
   * @secure
   */
  getUserCourseInstanceById = (
    userCourseInstanceId: string,
    params: RequestParams = {},
  ) =>
    this.request<UserCourseInstanceModel, NotFoundExceptionModel>({
      path: `/api/UserCourseInstance/${userCourseInstanceId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags UserCourseInstance
   * @name GetMyUserCourseInstance
   * @request GET:/api/UserCourseInstance/{userCourseInstanceId}/my
   * @secure
   */
  getMyUserCourseInstance = (
    userCourseInstanceId: string,
    params: RequestParams = {},
  ) =>
    this.request<UserCourseInstanceModel, NotFoundExceptionModel>({
      path: `/api/UserCourseInstance/${userCourseInstanceId}/my`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags UserCourseInstance
   * @name GenerateMyCert
   * @request GET:/api/UserCourseInstance/{userCourseInstanceId}/certificate
   * @secure
   */
  generateMyCert = (userCourseInstanceId: string, params: RequestParams = {}) =>
    this.request<string, NotFoundExceptionModel>({
      path: `/api/UserCourseInstance/${userCourseInstanceId}/certificate`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
